import { FC } from 'react';
import styled from 'styled-components';
import type { Match } from '../../../../types';

const ContainerExtendedContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 20%;

    & .result-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 30%;

        & .result-text {
            font-size: 7px;
            font-weight: 500;
            color: white;
            text-align: center;
            width: 100%;
        }
    }

    & .notes-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 70%;

        & .notes-text {
            font-size: 7px;
            font-weight: 500;
            color: white;
            text-align: center;
            width: 100%;
            font-style: italic;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 100%;
        }
    }
`;

interface RenderingInfoExtendedContentProps {
    matchInfo: Match;
}

const RenderingInfoExtendedContent: FC<RenderingInfoExtendedContentProps> = ({ matchInfo }) => {
    return (
        <ContainerExtendedContent className='container-extended-content'>
            <div className='result-container'>
                <span className='result-text'>
                    {/* Se no is_no_contest è true, faccio vedere NO CONTEST, altrimenti ciclo winners */}
                    {matchInfo.is_no_contest ? 'NO CONTEST' : matchInfo.winners.map((winner, key) => (
                        // Vincitori separati da '|' se non è l'ultimo
                        <span
                            key={key}
                            className='result-text'
                        >Vincitore: {winner.name}{key !== matchInfo.winners.length - 1 ? ' | ' : ''}</span>
                    ))}
                </span>
            </div>
            <div className='notes-container'>
                <span className='notes-text'>
                {/* Se note presenti le faccio vedere, altrimenti scritta: Nessun evento da segnalare */}
                    {matchInfo.notes ? (
                        <span className='notes-text'>
                            {matchInfo.notes}
                        </span>
                    ) : (
                        <span className='notes-text'>Nessun evento da segnalare</span>
                    )}
                </span>
            </div>
        </ContainerExtendedContent>
    )
}

export default RenderingInfoExtendedContent;
